import {AppFromBackapi} from '../MiniPicks.types';
import Pick from '../Pick/Pick';
import styles from './PlaceholderPicks.module.scss';

export const PlaceholderPicks = ({apps}: {apps: Array<AppFromBackapi>}) => {
  return (
    <div className={styles.wrapper}>
      {apps.map((pick) => (
        <a key={pick.appId} href={pick.catalogUrl}>
          <Pick pick={pick} />
        </a>
      ))}
    </div>
  );
};
